"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResourceBar = void 0;
const retrommo_types_1 = require("retrommo-types");
const pixel_pigeon_1 = require("pixel-pigeon");
const createImage_1 = require("./createImage");
const createResourceBar = ({ condition, iconImagePath, maxValue, primaryColor, secondaryColor, value, x, y, }) => {
    (0, createImage_1.createImage)({
        condition,
        height: 8,
        imagePath: "calipers",
        width: 41,
        x,
        y,
    });
    const maxFillingWidth = 38;
    const fillingWidth = () => {
        const calculatedValue = typeof value === "number" ? value : value();
        const calculatedMaxValue = typeof maxValue === "number" ? maxValue : maxValue();
        const percentageWidth = Math.ceil((maxFillingWidth * calculatedValue) / calculatedMaxValue);
        const maxed = calculatedValue === calculatedMaxValue;
        const minned = calculatedValue === 0;
        return maxed === false && percentageWidth === maxFillingWidth
            ? percentageWidth - 1
            : minned === false && percentageWidth === 0
                ? percentageWidth + 1
                : percentageWidth;
    };
    (0, pixel_pigeon_1.createQuadrilateral)({
        color: primaryColor,
        coordinates: {
            condition,
            x: (typeof x === "number" ? x : x()) + 3,
            y: (typeof y === "number" ? y : y()) + 5,
        },
        height: 2,
        width: fillingWidth,
    });
    (0, pixel_pigeon_1.createQuadrilateral)({
        color: secondaryColor,
        coordinates: {
            condition,
            x: () => (typeof x === "number" ? x : x()) + 3,
            y: () => (typeof y === "number" ? y : y()) + 7,
        },
        height: 1,
        width: fillingWidth,
    });
    (0, createImage_1.createImage)({
        condition,
        height: 7,
        imagePath: iconImagePath,
        width: 7,
        x: (typeof x === "number" ? x : x()) + 4,
        y,
    });
    (0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition,
            x: (typeof x === "number" ? x : x()) + 37,
            y,
        },
        horizontalAlignment: "right",
        text: () => ({
            value: String(typeof value === "number" ? value : value()),
        }),
    });
};
exports.createResourceBar = createResourceBar;
